import styled from "styled-components";
import { Color } from "@styles/constants";
import { Heading4CSS, BodyMediumCSS, PortableTextWrapper } from "@styles/typography";
import ExpandSVG from "@images/expand.svg";

export const StyledDetailAccordion = styled.div`
  position: relative;

  .Collapsible {
    ${Heading4CSS}

    border-bottom: 0;

    &::before,
    &::after {
      content: "";
      position: absolute;
      left: 0;
      width: 100%;
      height: 1px;
      background: #3e3e3e;
    }
  }

  //The content within the collaspable area
  .Collapsible__contentInner {
    padding: 0 0 10px;
    font-size: 14px;

    p {
      margin-bottom: 10px;
      font-size: 14px;
      line-height: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  //The link which when clicked opens the collapsable area
  .Collapsible__trigger {
    ${BodyMediumCSS}
    display: block;
    font-weight: 400;
    text-decoration: none;
    position: relative;
    padding: 10px 0;
    width: 100%;
    text-align: left;
    cursor: pointer;

    &:focus-visible {
      outline: -webkit-focus-ring-color auto 1px;
    }

    &:after {
      content: "";
      background: url(${ExpandSVG}) center center no-repeat;
      width: 20px;
      height: 20px;
      position: absolute;
      right: 0;
      top: 13px;
      display: block;
      transition: transform 300ms;
    }

    &.is-open {
      &:after {
        transform: rotateZ(45deg);
      }

      + .Collapsible__contentOuter {
        visibility: visible;
        transition: height 200ms ease-out, visibility 0s linear 0s !important;
      }
    }

    &.is-disabled {
      opacity: 0.5;
      background-color: $gray;
    }
  }

  .Collapsible__contentOuter {
    visibility: hidden;
    transition: height 200ms ease-out, visibility 0s linear 200ms !important;
  }
`;

export const StyledContent = styled(PortableTextWrapper)`
  max-width: 60ch;
  padding-bottom: 10px;
`;

export const StyledTextFallback = styled.div`
  border-top: 1px solid ${Color.blackBrand};
  padding: 10px 0;

  span {
    ${BodyMediumCSS}
  }

  ${StyledDetailAccordion}:last-child & {
    border-bottom: 1px solid ${Color.blackBrand};
  }
`;
